import React, { useState, useEffect, useRef } from 'react';
import { Menu, message, Button, Tooltip } from 'antd';
import { getQuery } from '@/common/utils/browser';
import { LeftOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { withRouter, Link } from 'react-router-dom';
import apis from '../../apis';
import './index.less';
import Detail from './components/detail';
import AddPage from './components/addPage';
import { enhancedFormateTimeStamp } from '@/common/utils';
import provideActivityLink from '@/components/provide-activity-link';

const VenueDetail = (props) => {
  const [selectedKey, setSelectedKey] = useState(0);
  const [venueData, setVenueData] = useState({});
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { toVenue, toUploadMaterial, toEditMaterial } = provideActivityLink.useActivityLink();
  const [setting, setSetting] = useState({
    settingStatus: '',
    startTime: '',
    endTime: '',
    offlineMsg: '',
    materialCode: '',
  });
  const statusRef = useRef(null);
  const towerId = getQuery('towerId');
  const planCode = getQuery('planCode');
  const detailRef = useRef();

  statusRef.current = getUploadMaterialBtnStatus;
  const handleClick = (e) => {
    setSelectedKey(e.key);
    detailRef.current.refresh();
  };

  useEffect(() => {
    const query = {
      towerId: getQuery('towerId'),
    };
    apis
      .actRoomRoomHeader(query)
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret === '0') {
          setVenueData(data.roomHeader);
          setSelectedKey(data.roomHeader.pages[0].id);
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });

    statusRef.current();
  }, [refresh]);

  function getUploadMaterialBtnStatus() {
    apis
      .potSettingInfo({ planCode: planCode, towerId })
      .then((res) => {
        if (res && res.ret === '0' && res.data) {
          setSetting({
            settingStatus: res.data.settingStatus,
            startTime: res.data.startTime || '',
            endTime: res.data.endTime || '',
            offlineMsg: res.data.offlineMsg || '',
            materialCode: res.data.materialCode,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getData = () => {
    if (!venueData.pages) return;
    const result = venueData.pages.filter((item) => item.id === selectedKey);
    return result[0] ? { data: result[0], otherData: { ...venueData } } : false;
  };

  const linkToEditMaterial = toEditMaterial(planCode, towerId, setting.materialCode).get();
  const linkToUploadMaterial = toUploadMaterial(planCode, towerId).get();

  // TOFIX: 通过planCode判断是否合适，是否准确？
  function renderBtn() {
    switch (setting.settingStatus) {
      case 0:
        return null;
      case 1:
        return (
          <>
            <span>{enhancedFormateTimeStamp(setting.startTime, 'YY-MM-DD hh:mm:ss')} 开始上传！</span>
            <Button
              disabled
              className="venueDetail__upload-material"
              onClick={() => {
                setVisible(true);
              }}
            >
              上传分会场素材
            </Button>
          </>
        );
      case 2:
        return (
          <>
            <span>{enhancedFormateTimeStamp(setting.endTime, 'YY-MM-DD hh:mm:ss')} 截止上传！</span>
            <Link to={linkToUploadMaterial}>
              <Button className="venueDetail__upload-material">上传分会场素材</Button>
            </Link>
          </>
        );
      case 3:
        return (
          <>
            <span>已上传成功！</span>
            <Link to={linkToEditMaterial}>
              <Button className="venueDetail__upload-material">编辑分会场素材</Button>
            </Link>
          </>
        );
      case 4:
        return (
          <>
            <span style={{ color: '#F52F3E' }}>
              被下线！请重新上传
              <Tooltip title={setting.offlineMsg}>
                <QuestionCircleOutlined style={{ fontSize: '16px', marginRight: '10px', marginLeft: '5px' }} />
              </Tooltip>
            </span>
            <Link to={linkToEditMaterial}>
              <Button className="venueDetail__upload-material">编辑分会场素材</Button>
            </Link>
          </>
        );
      case 5:
        return (
          <>
            <span>上传时间已截止！</span>
            <Link to={linkToUploadMaterial}>
              <Button disabled className="venueDetail__upload-material">
                上传分会场素材
              </Button>
            </Link>
          </>
        );
      case 6:
        return (
          <>
            <span>已上传成功！</span>
            <Link to={linkToEditMaterial}>
              <Button className="venueDetail__upload-material">编辑分会场素材</Button>
            </Link>
          </>
        );
      case 7:
        return (
          <>
            <span style={{ color: '#F52F3E' }}>
              被下线！
              <Tooltip title={setting.offlineMsg}>
                <QuestionCircleOutlined style={{ fontSize: '16px', marginRight: '10px', marginLeft: '5px' }} />
              </Tooltip>
            </span>
            <span>上传时间已截止！</span>
            <Link to={linkToUploadMaterial}>
              <Button disabled className="venueDetail__upload-material">
                上传分会场素材
              </Button>
            </Link>
          </>
        );
    }
  }

  // TOFIX: 通过planCode判断是否合适，是否准确？
  const goBack = () => {
    const planCode = getQuery('planCode');
    // 存在planCode是正向流程
    if (planCode) {
      // props.history.push(avenueLinks(planCode))
      toVenue(planCode).replace();
    } else {
      props.history.push('/activity-manage/myCreate/avenue');
    }
  };

  return (
    <div className="venueDetail__wrapper">
      <LeftOutlined style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }} />
      <div className="venueDetail__back" style={{ display: 'inline-block' }} onClick={goBack}>
        <span> 返回全部项目</span>
      </div>
      <div className="venueDetail__title__wrapper">
        <div className="venueDetail__title">{venueData.name}</div>
        <div className="btn-wrap">
          {renderBtn()}
          <Button
            type="primary"
            className="venueDetail__add-page"
            onClick={() => {
              setVisible(true);
            }}
          >
            <PlusOutlined />
            新建页面
          </Button>
        </div>

        <AddPage
          visible={visible}
          setVisible={setVisible}
          towerId={getQuery('towerId')}
          planCode={getQuery('planCode')}
          refresh={refresh}
          setRefresh={setRefresh}
          name={venueData.name}
        />
      </div>
      <Menu onClick={handleClick} selectedKeys={[selectedKey]} mode="horizontal">
        {venueData.pages && venueData.pages.map((item) => <Menu.Item key={item.id}>{item.name}</Menu.Item>)}
      </Menu>
      {getData() && (
        <Detail {...getData()} towerId={getQuery('towerId')} planCode={getQuery('planCode')} ref={detailRef} />
      )}
    </div>
  );
};

export default withRouter(VenueDetail);
